module.exports = __webpack_public_path__ + "static/img/quxiaojingyin2.d47d173.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/quxiaojingyin2.png
// module id = dnwj
// module chunks = 24